/* ============================================================
   Vibe Boutique — Homepage Interactive JS
   Loaded ONLY on homepage (template.name == 'index')
   Vanilla JS ES2020, no dependencies
   ============================================================ */

(function () {
  'use strict';

  /* ── Config ── */
  /* Brandurile promise trebuie sa existe in catalog — dar catalogul se misca:
     pe 2026-08-04 HUGO, Marc O'Polo si Armani aveau ~0 produse si au fost scoase;
     pe 2026-08-12 aveau 52, 12 si ~7, deci s-au intors (decizia Roxi). Nu edita
     lista dupa o numaratoare veche: numara intai in catalogul de azi
     (products.json, per vendor). Scos doar Lacoste (1 produs). */
  var BRANDS = [
    'Hugo Boss',
    'Tommy Hilfiger',
    'Calvin Klein',
    'Armani',
    'Jack & Jones',
    'HUGO'
  ];

  var MARQUEE_BRANDS = [
    'Hugo Boss', 'Tommy Hilfiger', 'Calvin Klein',
    'Armani', 'Jack & Jones', 'HUGO',
    'Pepe Jeans', 'Tom Tailor', 'Marc O\'Polo'
  ];

  /* 1. CURSOR PERSONALIZAT — ELIMINAT 2026-07-31.
     Ascundea cursorul nativ pe tot situl si desena un punct din JS. Un punct
     mutat din `mousemove` nu poate tine pasul cu cursorul real, pe care il
     misca sistemul de operare — de aici senzatia de intarziere. Iar orice
     element din "top layer" (dialog deschis cu showModal, select nativ,
     autocomplete) se desena PESTE punct, lasand utilizatorul fara niciun
     reper vizibil: modalul de cautare a fost exact acest caz.
     Nu se repara cu petice; problema e in idee. Nu-l readuce. */

  /* ─────────────────────────────────────────────────
     2. HERO OVERLAY
     Server-rendered în snippets/vb-hero-overlay.liquid
     (SEO/AEO: conținutul există în HTML, nu se mai injectează din JS)
  ───────────────────────────────────────────────── */

  /* ─────────────────────────────────────────────────
     3. BRAND WORD ROTATION
     Fade cross-dissolve, 2.5s interval
  ───────────────────────────────────────────────── */
  function initBrandRotation() {
    var el = document.getElementById('vb-brand-word');
    if (!el) return;

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    var idx = 0;
    setInterval(function () {
      el.style.opacity = '0';
      setTimeout(function () {
        idx = (idx + 1) % BRANDS.length;
        el.textContent = BRANDS[idx];
        el.style.opacity = '1';
      }, 420);
    }, 2500);
  }

  /* ─────────────────────────────────────────────────
     4. BRAND MARQUEE BAND (injected after hero)
  ───────────────────────────────────────────────── */
  function injectBrandsMarquee() {
    var hero = document.querySelector('[id^="Hero-"]');
    if (!hero) return;

    /* Build the scrolling items (doubled for seamless loop) */
    var items = MARQUEE_BRANDS.concat(MARQUEE_BRANDS);
    var html = items.map(function (b) {
      return '<span>' + b.replace(/&/g, '&amp;') + '</span>';
    }).join('');

    var marquee = document.createElement('div');
    marquee.className = 'vb-brands-marquee';
    marquee.setAttribute('aria-hidden', 'true');
    marquee.innerHTML = '<div class="vb-brands-track">' + html + '</div>';

    /* Insert immediately AFTER the hero shopify-section */
    var heroSection = hero.closest('.shopify-section') || hero.parentNode;
    if (heroSection.nextSibling) {
      heroSection.parentNode.insertBefore(marquee, heroSection.nextSibling);
    } else {
      heroSection.parentNode.appendChild(marquee);
    }
  }

  /* ─────────────────────────────────────────────────
     INIT
  ───────────────────────────────────────────────── */
  function init() {
    /* Guard: only run if hero is on page */
    if (!document.querySelector('[id^="Hero-"]')) return;

    initBrandRotation();
    injectBrandsMarquee();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
